export default "__VITE_ASSET__CXhfHcrp__"